import { defineMessages } from '@jutro/locale';

export default defineMessages({
    loading: {
        id: 'ml.gateway.views.ProducerNews.mlProducerNewsComponent.Loading...',
        defaultMessage: 'Loading...'
    },
    yesterday: {
        id: 'ml.gateway.views.ProducerNews.mlProducerNewsComponent.Yesterday',
        defaultMessage:
            'Yesterday'
    },
    tomorrow: {
        id: 'ml.gateway.views.ProducerNews.mlProducerNewsComponent.Tomorrow',
        defaultMessage:
            'Tomorrow'
    },
    today: {
        id: 'ml.gateway.views.ProducerNews.mlProducerNewsComponent.Today',
        defaultMessage:
            'Today'
    }
    
});
